"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleSearchOutput = exports.defineVehiclePanelFromPassengerNbr = exports.defineEngineTypeFromExternalVehicleAPIEnergie = void 0;
const class_validator_1 = require("class-validator");
const defineEngineTypeFromExternalVehicleAPIEnergie = (energie) => {
    if (energie === 'ELECTRIC' || energie === 'ELECTRIQUE' || energie === 'EL') {
        return 'ELECTRIC';
    }
    else if (energie.includes('HNR') || energie.includes('ELEC HYBRIDE') || energie === 'HYBRIDE/ESSENCE' || energie == 'EH') {
        return 'SIMPLE_HYBRID';
    }
    else if (energie.includes('HR') || energie === 'ESSENCE-ELEC RECHARGEABLE') {
        return 'PLUGIN_HYBRID';
    }
    else if (energie === 'GAZOLE' || energie === 'GASOIL' || energie === 'GO') {
        return 'DIESEL';
    }
    else {
        return 'GASOLINE';
    }
};
exports.defineEngineTypeFromExternalVehicleAPIEnergie = defineEngineTypeFromExternalVehicleAPIEnergie;
const defineVehiclePanelFromPassengerNbr = (passengerNumber) => {
    if (passengerNumber === 1) {
        return 'MOTO';
    }
    else if (passengerNumber <= 6) {
        return 'BERLINE';
    }
    else {
        return 'VAN';
    }
};
exports.defineVehiclePanelFromPassengerNbr = defineVehiclePanelFromPassengerNbr;
class VehicleSearchOutput {
    static outputFromExternalVehicle(vehicle) {
        const output = new VehicleSearchOutput();
        output.licensePlate = vehicle.data.AWN_immat;
        output.bodyworkType = vehicle.data.AWN_carrosserie;
        output.vinCode = vehicle.data.AWN_VIN;
        output.conso = vehicle.data.AWN_consommation_mixte;
        output.color = vehicle.data.AWN_couleur;
        output.firstDate = vehicle.data.AWN_date_mise_en_circulation;
        output.energie = vehicle.data.AWN_energie;
        output.brand = vehicle.data.AWN_marque;
        output.range = vehicle.data.AWN_modele;
        output.nbPassengers = vehicle.data.AWN_nbr_de_places ? +vehicle.data.AWN_nbr_de_places - 1 : 0;
        output.doorNbr = vehicle.data.AWN_nbr_portes ? +vehicle.data.AWN_nbr_portes : 0;
        output.co2 = vehicle.data.AWN_emission_co_2 ? +vehicle.data.AWN_emission_co_2 : -1;
        output.engineType = (0, exports.defineEngineTypeFromExternalVehicleAPIEnergie)(output.energie);
        output.panelKeys = [(0, exports.defineVehiclePanelFromPassengerNbr)(output.nbPassengers)];
        if (output.engineType === 'ELECTRIC' || output.engineType === 'PLUGIN_HYBRID' || output.engineType === 'SIMPLE_HYBRID') {
            output.panelKeys.push('GREEN');
        }
        return output;
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "licensePlate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "bodyworkType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "vinCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "conso", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "color", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "firstDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "energie", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "brand", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "range", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], VehicleSearchOutput.prototype, "nbPassengers", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], VehicleSearchOutput.prototype, "doorNbr", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], VehicleSearchOutput.prototype, "co2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(['DIESEL', 'GASOLINE', 'SIMPLE_HYBRID', 'PLUGIN_HYBRID', 'ELECTRIC']),
    __metadata("design:type", String)
], VehicleSearchOutput.prototype, "engineType", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], VehicleSearchOutput.prototype, "options", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], VehicleSearchOutput.prototype, "panelKeys", void 0);
exports.VehicleSearchOutput = VehicleSearchOutput;
